import Vue from 'vue';
import VueRouter from 'vue-router';
import VueResource from 'vue-resource';

import di from 'di';
import corePlugins from 'js-core/js/bootstrap/plugins';

export default function() {

    const config = di.get('config');

    // Core
    corePlugins();

    // Router
    Vue.use(VueRouter);

    // Resource
    Vue.use(VueResource);
    Vue.http.options.root = config.apiUrl;
}
